import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as TagActions from 'web-app/react/entities/tags/actions';

import * as Actions from './actions';

const State = Record({
    loading: false,
    updatingTags: List(),
});

export default handleActions(
    {
        [Actions.add.type]: (state, {payload}) =>
            state.merge({
                updatingTags: state.updatingTags.push(payload.tagId),
            }),
        [Actions.addSuccess.type]: (state, {payload}) =>
            state.merge({
                updatingTags: state.updatingTags.filter(tagId => tagId !== payload.tagId),
            }),
        [Actions.addFailed.type]: (state, {payload}) =>
            state.merge({
                updatingTags: state.updatingTags.filter(tagId => tagId !== payload.tagId),
            }),
        [Actions.remove.type]: (state, {payload}) =>
            state.merge({
                updatingTags: state.updatingTags.push(payload.tagId),
            }),
        [Actions.removeSuccess.type]: (state, {payload}) =>
            state.merge({
                updatingTags: state.updatingTags.filter(tagId => tagId !== payload.tagId),
            }),
        [Actions.removeFailed.type]: (state, {payload}) =>
            state.merge({
                updatingTags: state.updatingTags.filter(tagId => tagId !== payload.tagId),
            }),
        [TagActions.fetchAll.type]: state =>
            state.merge({
                loading: true,
            }),
        [TagActions.fetchAllSuccess.type]: state =>
            state.merge({
                loading: false,
            }),
        [TagActions.fetchAllFailed.type]: state =>
            state.merge({
                loading: false,
            }),
    },
    new State(),
);
